import React, {useEffect} from 'react';
import { createBrowserHistory } from 'history';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import configureStore from './redux/configureStore';
import { Switch, Route, BrowserRouter as Router, Redirect } from 'react-router-dom';

import './App.css';
import Login from './components/Login';
import CreatePassword from './components/CreatePassword';
import EIFMSG from './components/EIFMSG';
import EIF from './components/EIF';
import IpfConfigure from './components/IpfConfigure';
import QuestionsList from './components/Questionslist';
import AddQuestion from './components/AddQuestion';
import PrivateRoute from '../src/PrivateRoute';
import Configure from './components/Configure';
import AddQuestionCategory from './components/AddQuestionCategory';
import QuestionsCategorylist from './components/QuestionsCategorylist';
import EIFList from './components/EIFList';
import RAFList from './components/RAFList';
import Header from './components/Header';
import RAF from './components/RAF';
import RAFMSG from './components/RAFMSG';
import FindDomain from './components/FindDomain';
import AddUser from './components/AddUser';
import Userslist from './components/Userslist';
import TesterList from './components/TesterList';
import Organizationlist from './components/Organizationlist';
import ChangePassword from './components/ChangePassword';
import AddOrganization from './components/AddOrganization';
import EmailList from './components/Emaillist';
import BillingDetails from './components/BillingDetails';
import QuestionConfigure from './components/QuestionConfigure/QuestionConfigure';
import KidReportConfigureForm from './components/KidReportConfigure/KidReportConfigureForm';
import AuditReportsList from './components/AuditReports/AuditReportLogs';
import RolesConfiguration from './components/RolesConfigure/RolesConfigure';
import NotificationConfigureForm from './components/NotificationConfigure/NotificationConfigureForm';
import FormConfigure from './components/FormConfigure';
import ConfigureOrg from './components/ConfigureOrg';
import DashboardDetails from './components/DashboardDetails';
import Preview from './components/Preview_Questions';
import { logOut } from './api/api';
import PageNotFound from './components/PageNotFound';
import AddOrgUser from './components/AddOrgUser';
import IdleTimerComponent from './components/IdleTimerComponent';
import MappingScreen from './components/MappingFields/MappingFields';
import APIKeysConfigure from './components/APIKeys/APIKeysConfigure';

export const { store, persistor } = configureStore(createBrowserHistory());


function App () {

    useEffect(() => {
        const entries = performance.getEntriesByType('navigation');
        const action = entries.map((nav) => nav.type);

        let token = localStorage.refreshToken ? (localStorage.refreshToken === undefined ? '' : localStorage.refreshToken === 'undefined' ? '' : localStorage.refreshToken) : '';
          
        if (token) {
            if (action[0] !== 'reload') {
                 logOut();
                //localStorage.removeItem('refreshToken');


            } else {
            }
        }
    },[])
  
    return (
            <div className="Container-fluid">
                
                <div className="App">
                  <IdleTimerComponent /> 
                    <Provider store={store}>
                        <PersistGate loading={null} persistor={persistor}>
                            <Router>
                                <Header refreshToken={localStorage.refreshToken} />
                                <Switch>
                                    <Route exact path="/">
                                        <Redirect to="/admin/configure" />
                                    </Route>
                                    <Route path="/admin/eif" component={EIF} />
                                    <Route path="/admin/eifmsg" component={EIFMSG} />
                                    <Route path="/admin/rafmsg" component={RAFMSG} />
                                    <Route path="/admin/login" component={Login} />
                                    <Route path="/admin/:token-password" component={CreatePassword} />
                                    <Route path="/admin/finddomain" component={FindDomain} />
                                    <Route path="/readiness_assessment/customer=:customer&category=:category" component={RAF} />
                                </Switch>
                                <Switch>
                                    <PrivateRoute path="/admin/access_denied" component={PageNotFound} roles={['Super Admin', 'Admin', 'Coordinator']} />
                                    <PrivateRoute path="/admin/changepassword" component={ChangePassword} roles={['Super Admin', 'Admin', 'Coordinator']} />
                                    <PrivateRoute path="/admin/preview" component={Preview} roles={['Super Admin', 'Admin']} />
                                    <PrivateRoute path="/admin/billing/org=:org&name=:name" component={BillingDetails} roles={['Super Admin', 'Admin']} />
                                    <PrivateRoute exact path="/admin/configure" component={Configure} roles={['Super Admin', 'Admin', 'Coordinator']} />
                                    <PrivateRoute path="/admin/configure/questions" component={QuestionsList} roles={['Super Admin', 'Admin']} />
                                    <PrivateRoute path="/admin/configure/question/edit=:edit&id=:id" component={AddQuestion} roles={['Super Admin', 'Admin']} />
                                    <PrivateRoute path="/admin/configure/addquestion" component={AddQuestion} roles={['Super Admin', 'Admin']} />
                                    <PrivateRoute path="/admin/configure/adduser" component={AddUser} roles={['Super Admin', 'Admin']} />
                                    <PrivateRoute path="/admin/configure/user/edit=:edit&id=:id" component={AddUser} roles={['Super Admin', 'Admin']} />
                                    <PrivateRoute path="/admin/configure/userslist" component={Userslist} roles={['Super Admin', 'Admin']} />
                                    <PrivateRoute path="/admin/configure/addorganization" component={AddOrganization} roles={['Super Admin', 'Admin']} />
                                    <PrivateRoute path="/admin/configure/organizationlist" component={Organizationlist} roles={['Super Admin', 'Admin']} />
                                    <PrivateRoute path="/admin/configure/ipf" component={IpfConfigure} roles={['Super Admin', 'Admin']} />
                                    <PrivateRoute path="/admin/configure/organization/edit=:edit&id=:id" component={AddOrganization} roles={['Super Admin', 'Admin']} />
                                    <PrivateRoute path="/admin/configure/questioncategory" component={AddQuestionCategory} roles={['Super Admin', 'Admin']} />
                                    <PrivateRoute path="/admin/eiflist" component={EIFList} roles={['Super Admin', 'Admin', 'Coordinator']} />
                                    <PrivateRoute path="/admin/raflist" component={RAFList} roles={['Super Admin', 'Admin', 'Coordinator']} />
                                    <PrivateRoute path="/admin/configure/emailslist" component={EmailList} roles={['Super Admin', 'Admin', 'Coordinator']} />


                                    <PrivateRoute path="/admin/org-configure/" component={ConfigureOrg} roles={['Super Admin', 'Admin']} />
                                    <PrivateRoute path="/admin/questions-configure/Org=:Org&id=:id&Config=:Config&subConfig=:subConfig&subLabel=:subLabel" component={QuestionConfigure} roles={['Super Admin', 'Admin']} />
                                    <PrivateRoute path="/admin/dashboard-details/Org=:Org&id=:id&Config=:Config&subConfig=:subConfig&subLabel=:subLabel" component={DashboardDetails} roles={['Super Admin', 'Admin']} />
                                    <PrivateRoute path="/admin/notifications-configure/Org=:Org&id=:id&Config=:Config&subConfig=:subConfig&subLabel=:subLabel" component={NotificationConfigureForm} roles={['Super Admin', 'Admin']} />
                                    <PrivateRoute path="/admin/kid-report-configure/Org=:Org&id=:id&Config=:Config&subConfig=:subConfig&subLabel=:subLabel" component={KidReportConfigureForm} roles={['Super Admin', 'Admin']} />
                                    <PrivateRoute path="/admin/audit-report/Org=:Org&id=:id&Config=:Config&subConfig=:subConfig&subLabel=:subLabel" component={AuditReportsList} roles={['Super Admin', 'Admin']} />
                                    <PrivateRoute path="/admin/role-configuration/Org=:Org&id=:id&Config=:Config&subConfig=:subConfig&orgType=:orgType&subLabel=:subLabel" component={RolesConfiguration} roles={['Super Admin', 'Admin']} />
                                    <PrivateRoute path="/admin/forms-configure/Org=:Org&id=:id" component={FormConfigure} roles={['Super Admin', 'Admin']} />
                                    <PrivateRoute path="/admin/configure-tester-list/Org=:Org&id=:id" component={TesterList} roles={['Super Admin']} />


                                    <PrivateRoute path="/admin/configure/questioncategorylist" component={QuestionsCategorylist} roles={['Super Admin', 'Admin']} />
                                    <PrivateRoute path="/admin/configure/organization/adduser/id:id" component={AddOrgUser} roles={['Super Admin', 'Admin']} />
                                    <PrivateRoute path="/admin/mapping-configure/Org=:Org&id=:id&Config=:Config&subConfig=:subConfig&orgType=:orgType&subLabel=:subLabel" component={MappingScreen} roles={['Super Admin', 'Admin']} />
                                    <PrivateRoute path="/admin/api-keys/Org=:Org&id=:id&Config=:Config&subConfig=:subConfig&orgType=:orgType&subLabel=:subLabel" component={APIKeysConfigure} roles={['Super Admin', 'Admin']} />
                                </Switch>
                            </Router>
                        </PersistGate>
                    </Provider>
                </div>
            </div>
        );

}

export default App;
